/**
 * Checks if a Merkl breakdown is related to Morpho protocol.
 *
 * Verified opportunities expose `protocol.id = morpho`; some valid vault-level
 * Merkl breakdowns are returned as unverified opportunities and omit protocol
 * metadata while still carrying the `morpho` tag.
 */
export const isMorphoBreakdown = (opportunity: {
  protocol?: { id?: string | null } | null
  tags?: string[] | null
}): boolean =>
  opportunity.protocol?.id?.toLowerCase() === 'morpho' ||
  opportunity.tags?.some(tag => tag.toLowerCase() === 'morpho') === true
